var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinesLeft = function SvgLinesLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 8,
    fill: "none",
    viewBox: "0 0 34 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M17.17 5.5H34v2H17.17zM.34.5H34v2H.34z"
  })));
};
export default SvgLinesLeft;